import {EnvelopBody, WebSocketAbstract, WebSocketEnvelop} from './websocket-abstract';

export class WebSocketJboss extends WebSocketAbstract {
    private _socket: WebSocket;

    get readyState(): number {
        return this._socket ? this._socket.readyState : null;
    }

    stateChange() {
        if (this.readyState === WebSocket.OPEN) {
            this._ping();
        }
        super.stateChange();
    }

    connect(options: string, username: string) {
        this._socket = new WebSocket(options);
        this._socket.onmessage = (event) => {
            // const envelop: WebSocketEnvelop = JSON.parse(event.data);
            // if (envelop.body) {
            //     this.onMessage.next(envelop.body);
            // }
            const envelopBody: EnvelopBody = JSON.parse(event.data);
            if (envelopBody.sender) {
                this.onMessage.next(envelopBody);
            }
        };
        this._socket.onopen = () => this.stateChange();
        this._socket.onerror = () => this.stateChange();
        this._socket.onclose = () => this.stateChange();
    }

    close() {
        this._socket.close();
    }

    send(envelop: WebSocketEnvelop): Promise<boolean> {
        return new Promise(resolve => {
            try {
                this._socket.send(JSON.stringify(envelop));
                resolve(true);
            } catch(e) {
                resolve(false);
                console.warn('Send message failed', e);
            }
        });
    }

    private _ping() {
        if (this.readyState === WebSocket.OPEN) {
            this._socket.send(JSON.stringify({type: 'ping'}));
            setTimeout(() => this._ping(), 10000);
        }
    }
}
